import { AuthMode, AuthModeState } from '../types/authMode';

const defaultState: AuthModeState = AuthMode.UNKNOWN;

export default function authMode(state = defaultState, action): AuthModeState {
  return state;
}
